import { Flex, Spin, Tooltip } from "antd";
import React from "react";

interface ExpandableButtonProps {
  icon: React.ReactNode;
  text: string;
  onClick?: () => void;
  loading?: boolean;
  isExpanded?: boolean;
  disabled?: boolean;
}

const ExpandableButton: React.FC<ExpandableButtonProps> = ({
  icon,
  text,
  onClick,
  loading,
  isExpanded,
  disabled,
}) => {
  const buttonContent = (
    <Flex
      align="center"
      justify="center"
      className={`rounded-lg cursor-pointer ${isExpanded ? "w-auto " : "hover:w-auto"} group ${disabled
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-utility-brand-500_alt hover:bg-brand-secondary-700"
        }`}
      onClick={!disabled ? onClick : undefined}
    >
      {loading ? (
        <span className="p-2">
          <Spin size="small" />
        </span>
      ) : (
        <span className="p-2 h-10 flex items-center">{icon}</span>
      )}
      <span
        className={`text-white text-sm overflow-hidden ${isExpanded ? "w-auto max-w-52 pr-3" : "max-w-0"} ${loading ? "" : "group-hover:max-w-52 group-hover:pr-3"
          } whitespace-nowrap transition-all duration-300`}
      >
        {text}
      </span>
    </Flex>
  );

  return disabled ? <Tooltip title="This feature is not supported in this plan. please upgrade your plan!">{buttonContent}</Tooltip> : buttonContent;
};

export default ExpandableButton;
